import React from "react";
import Icon from "../../setup/Icon";
import { playstylePresentation } from "../../setup/presets";
import styles from "../play.module.scss";

// The match's game mode (playstyle), the same chip the lobby cards wear: a dark
// pill with the mode's icon and name in its accent colour. GameLayout places it
// (the toolbar row on the roomy rail, its own slim line on the compact panel).
export default function ModeChip({ playstyle }: { playstyle: string }) {
  const { icon, color } = playstylePresentation(playstyle);
  return (
    <span className={styles.modeChip} style={{ color }} title={`Game mode: ${playstyle}`}>
      <Icon name={icon} size={13} />
      <span>{playstyle}</span>
    </span>
  );
}
